module.exports = __webpack_public_path__ + "img/2.5_Russian_road_sign.c0b2b49a.svg";